/**
 * Site-Konfiguration für die Website.
 *
 * Die Website ist pro Kunde geforkt — alle Werte werden über ENV-Variablen
 * gesetzt (Build- bzw. Runtime-Konfiguration). Defaults entsprechen der
 * MOBIKART-Referenzinstallation und können überschrieben werden.
 */

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export const SITE_URL = trimTrailingSlash(
  process.env.NEXT_PUBLIC_SITE_URL || 'https://www.mobi-kart.de',
);

export const SITE_NAME = process.env.NEXT_PUBLIC_SITE_NAME || 'MOBIKART';

export const SITE_DESCRIPTION =
  process.env.NEXT_PUBLIC_SITE_DESCRIPTION ||
  'Erlebe den ultimativen Nervenkitzel auf zwei Ebenen mit unseren Elektro-Go-Karts!';

export const SITE_KEYWORDS =
  process.env.NEXT_PUBLIC_SITE_KEYWORDS ||
  'GoKart, Kartbahn, Berlin, Indoor, Elektro-Kart, Kindergeburtstag, MOBIKART';

export const SITE_TITLE_DEFAULT =
  process.env.NEXT_PUBLIC_SITE_TITLE_DEFAULT ||
  'MOBIKART - Die größte GoKart Indoorbahn Berlins';

export const SITE_TITLE_TEMPLATE =
  process.env.NEXT_PUBLIC_SITE_TITLE_TEMPLATE || '%s | MOBIKART';

export const SITE_OG_IMAGE =
  process.env.NEXT_PUBLIC_SITE_OG_IMAGE ||
  'https://www.mobi-kart.de/images/home/hero/banner1.jpg';

// Firmen-Logo für strukturierte Daten (schema.org Organization/LocalBusiness).
export const SITE_LOGO =
  process.env.NEXT_PUBLIC_SITE_LOGO || `${SITE_URL}/logo.svg`;

// Optionale Geo-Koordinaten (nur ausgeben, wenn gesetzt — keine erfundenen Werte).
const geoLat = process.env.NEXT_PUBLIC_COMPANY_GEO_LAT;
const geoLng = process.env.NEXT_PUBLIC_COMPANY_GEO_LNG;

export const COMPANY = {
  name: process.env.NEXT_PUBLIC_COMPANY_NAME || 'MOBIKART Fun Racing GmbH',
  street: process.env.NEXT_PUBLIC_COMPANY_STREET || 'Bornitzstraße 106',
  postalCode: process.env.NEXT_PUBLIC_COMPANY_POSTAL_CODE || '10365',
  city: process.env.NEXT_PUBLIC_COMPANY_CITY || 'Berlin',
  countryCode: process.env.NEXT_PUBLIC_COMPANY_COUNTRY || 'DE',
  email: process.env.NEXT_PUBLIC_COMPANY_EMAIL || 'info@mobi-kart.de',
  phone: process.env.NEXT_PUBLIC_COMPANY_PHONE || '030- 986 38 749',
  phoneHref:
    process.env.NEXT_PUBLIC_COMPANY_PHONE_HREF || 'tel:030-986-38-749',
  geo:
    geoLat && geoLng
      ? { lat: Number(geoLat), lng: Number(geoLng) }
      : undefined,
};

export const COMPANY_ADDRESS_LINE = `${COMPANY.street} · ${COMPANY.postalCode} ${COMPANY.city}`;

/**
 * Social-/Profil-Links (schema.org `sameAs` + Kontaktseite). Einzeln via ENV
 * überschreibbar. Defaults = MOBIKART-Referenzinstallation.
 */
// Social-Links kommen AUSSCHLIESSLICH aus den Backend-Settings
// (social.facebookUrl / social.instagramUrl). Bewusst kein ENV-/Code-Fallback:
// wer die Links im Admin leert, will sie weg haben — nicht, dass stillschweigend
// eine einkompilierte URL wieder auftaucht.

/**
 * Öffnungszeiten (spiegeln Footer + Kontaktseite). Geschlossene Tage (Mo/Di)
 * werden weggelassen. `dayOfWeek` in schema.org-Notation (Englisch).
 */
export const OPENING_HOURS: { days: string[]; opens: string; closes: string }[] = [
  { days: ['Wednesday', 'Thursday'], opens: '13:00', closes: '20:00' },
  { days: ['Friday'], opens: '13:00', closes: '22:00' },
  { days: ['Saturday'], opens: '10:00', closes: '22:00' },
  { days: ['Sunday'], opens: '10:00', closes: '18:00' },
];

export const PAYMENT_DESCRIPTION_PREFIX =
  process.env.NEXT_PUBLIC_PAYMENT_DESCRIPTION_PREFIX || 'MobiKart Buchung';
